class IndicatorModel {
  constructor(obj) {
    this.id = null;
    this.title = null;
    this.description = null;
    this.type = null;
    this.created_at = null;
    this.updated_at = null;
    this.deleted_at = null;

    this.image_url = null;
    this.comment = null;

    this.status = null;

    if (obj) {
      Object.assign(this, obj);
    }
  }

  get dto() {
    return {
      ...this,
      status_id: this.status ? this.status.id : null,
    };
  }
}

export default IndicatorModel;
